import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Watchlist } from '../../services/Contexture/Watchlist';
import { toast } from 'react-toastify';
import { selectAuthProfiles } from '../../redux/selectors/authSelectors';
import { useSelector } from 'react-redux';
import { ModalWrapper } from '../Modal';
import SingleSelectFilter from '../Filters/SingleSelectFilter';

library.add(fal);

const AddToProfile = ({ profilePrimary, docId }) => {
    const [watch, setWatch] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const allUserProfiles = useSelector(selectAuthProfiles);
    const handleCuratorAction = () => {
        setShowProfileModal(true);
        setSelectedProfile(null);
    };
    const getAvailableProfiles = () => {
        if (!profilePrimary?.repositoryId || !allUserProfiles) return [];

        const curatorProfiles = Object.values(allUserProfiles).filter(
            profile =>
                profile?.repositoryId === profilePrimary.repositoryId &&
                profile?.roles?.indexOf('curator') > -1
        );

        return curatorProfiles.map(profile => ({
            value: profile.profileId,
            label: profile.profileName || profile.profileId
        }));
    };

    const handleClick = async (e) => {
        try {
            const response = await Watchlist.addDocument(docId, {
                profileId: selectedProfile?.value,
            });

            if (response) {
                setWatch(true);
                setShowProfileModal(false);
                setSelectedProfile(null);
                toast.success('Added to watchlist', {
                    position: 'top-right',
                    autoClose: 3000,
                });
            }
        } catch (err) {
            toast.error('Failed to add to watchlist', {
                position: 'top-right',
                autoClose: 3000,
            });
        }
    };

    return (
        <>
            <Button
                onClick={handleCuratorAction}
                variant='text'
                disabled={watch}
                className="card-icon-button curator-action-btn"
                data-testid='add-to-watchlist-button'
            >
                <FontAwesomeIcon
                    icon={watch ? ['fal', 'check'] : ['fal', 'thumbs-up']}
                ></FontAwesomeIcon>
            </Button>
            <ModalWrapper
                show={showProfileModal}
                onHide={() => setShowProfileModal(false)}
                headerClass='w-100 text-start'
                title={'Choose Profile'}
                showFooter={true}
                showCancel={true}
                isDisableSaveBtn={!selectedProfile}
                onSubmit={handleClick}
                saveButtonText='Add to profile'
            >
                <p>This document will be added to the selected profile</p>
                <div className="form-group">
                    {/* <label htmlFor="profile-select">Profile:</label> */}
                    <SingleSelectFilter
                        value={selectedProfile || ''}
                        removeZindexStyle={true}
                        key='profile-select'
                        options={getAvailableProfiles() || []}
                        isClearable={true}
                        onChange={(value) => {
                            setSelectedProfile(value)
                        }}
                        placeholderText='Select Profile'
                    />
                </div>

            </ModalWrapper >

        </>
    );
};
export default AddToProfile;
